import React from "react"

export default props => (
  <h3 className={props.className} style={{ color: props.headingColor1 }}>
    {props.headingText1}{" "}
    <span style={{ color: props.headingColor2 }}>{props.headingText2}</span>
  </h3>
)
